import Immutable from 'seamless-immutable';
import createReducer from '../helpers/createReducer';
import state from '../store/calendar';

export default createReducer(state, {
  SET_EVENT_DAY: (state, { data }) => Immutable({ ...state, eventDay: data }),
  SET_LAST_VISITED_MONTH_VALUE: (state, { data }) => Immutable(
    { ...state, lastVisitedMonthValue: data }
  ),
  SET_WHOLE_MONTH_EVENT_OBJECT: (state, { data }) => Immutable(
    { ...state, wholeMonthEventObj: data }
  ),

});
